import { makeReducerPermission } from "../../index";

export const sendPasswordResetEmailPermission = makeReducerPermission({
  reducerName: "sendPasswordResetEmail",
});
